export class Select {
    items: SelectItem[];
    onChange: (event: Event, filter: SelectItem) => void;
    selected: SelectItem['value'] | null;
    open: boolean;

    constructor({ items = [], selected, onChange }: SelectConfig) {
        this.items = items;
        this.onChange = onChange;
        this.selected = selected ?? items[0].value;
        this.open = false;
    }

    reset() {
        this.selected = this.items.find((i) => i.default)?.value ?? this.items[0].value;
    }

    toggle() {
        this.open = !this.open;
    }

    close() {
        this.open = false;
    }

    get selectedItem() {
        return this.items.find((i) => i.value === this.selected);
    }

    select(event: Event, value: SelectItem['value']) {
        const item = this.items.find((i) => i.value === value);

        if (!item) return;

        this.selected = value;
        this.close();

        if (typeof this.onChange === 'function') {
            this.onChange(event, item);
        }
    }
}
